var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('platform-icon',{staticStyle:{"flex-shrink":"0"},attrs:{"platformId":_vm.row.platform_id}}),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row.shopName)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }